export const articles = [
  {
    id: 'article-001',
    title: '2025年夏季新番导览：最值得期待的十部作品',
    excerpt: '夏季新番季即将到来，我们为你精选了十部不容错过的重磅新作，从热血战斗到治愈日常，总有一部适合你。',
    content: `2025年夏季新番季即将拉开帷幕，各大动画制作公司纷纷拿出了看家本领。本季度的新番阵容堪称豪华，无论你是热血战斗的拥趸，还是治愈日常的爱好者，都能找到心动的作品。

## 鬼灭之刃 无限城篇 剧场版第一部

作为本季度最受瞩目的作品，ufotable再次展现了其顶尖的作画水准。无限城篇将分为三部剧场版上映，第一部聚焦炭治郎与上弦之四·半天狗的激战。从预告片来看，战斗场面的流畅度和冲击力都达到了新高度。

## 我推的孩子 第三季

赤坂明原作的人气作品迎来第三季。随着星野爱身世之谜的逐渐解开，剧情进入了最高潮。本季将揭晓演艺圈黑暗面的真相，Aqua的复仇计划也将迎来关键转折。

## 葬送的芙莉莲 第二季

前作以惊人的口碑和制作质量征服了无数观众，第二季自然备受期待。芙莉莲将继续她的旅程，新角色陆续登场，人与魔族之间的千年恩怨将揭开更多篇章。MADHOUSE再次向我们展示了什么是顶级的叙事节奏。

## 其他值得关注的作品

本季度还有《Re:从零开始的异世界生活 第三季》、《药屋少女的呢喃 第二季》、《间谍过家家 第三季》等续作强势回归。新作方面，《怪兽8号 第二季》和《胆大党》都是不容错过的惊喜之作。`,
    author: '樱花动漫编辑部',
    authorAvatar: 'editor-avatar',
    publishDate: '2025-06-28',
    category: '新番导览',
    readCount: 12856,
    commentCount: 342,
    tags: ['2025夏番', '新番推荐', '动画导览'],
    imageSeq: 'article-hero-001',
  },
  {
    id: 'article-002',
    title: '深度解析：为什么《葬送的芙莉莲》能成为现象级作品',
    excerpt: '从叙事结构到情感表达，从作画质量到音乐制作，全面解析这部治愈系神作的成功密码。',
    content: `《葬送的芙莉莲》第一季播出后，在动画界引发了广泛讨论。这部作品以其独特的叙事视角和深邃的情感表达，成为了近年来少有的现象级作品。

## 独特的时间观

与大多数冒险故事不同，《葬送的芙莉莲》将故事设定在"魔王已被打败之后"。芙莉莲作为长寿的精灵，以一种近乎旁观者的视角回望与勇者一行人的冒险，这种"后日谈"式的叙事角度令人耳目一新。

时间的流逝在作品中既是主题也是工具——它既是芙莉莲必须面对的痛苦（看着伙伴老去），也是她成长的催化剂（通过新的旅程理解"人心"）。

## 极致的制作水准

MADHOUSE在制作层面的投入令人惊叹。背景美术精致到每一帧都可以截图做壁纸，光影处理赋予了画面电影般的质感。Evan Call创作的配乐更是锦上添花，将作品的情感张力推向了新的高度。

## 治愈而不说教

《葬送的芙莉莲》最成功的地方在于它用一种极其克制的方式讲述"珍惜当下"。没有刻意的煽情，没有直白的说教，而是让观众在芙莉莲的旅程中自然而然地产生共鸣——这或许就是它能打动人心的根本原因。`,
    author: '二次元观察室',
    authorAvatar: 'editor-avatar-2',
    publishDate: '2025-06-20',
    category: '深度分析',
    readCount: 9872,
    commentCount: 256,
    tags: ['葬送的芙莉莲', '动画分析', '治愈系'],
    imageSeq: 'article-hero-002',
  },
  {
    id: 'article-003',
    title: '国产动漫崛起：盘点2025年最值得关注的国产动画',
    excerpt: '从《时光代理人》到《雾山五行》，国产动画正在以惊人的速度成长，让我们一起看看今年的亮点之作。',
    content: `2025年，国产动画继续保持了强劲的上升势头。越来越多高质量的国产动画作品获得了观众的认可，在国内外都取得了不俗的成绩。

## 《时光代理人》第三季

澜映画制作的这部悬疑时空穿越题材动画，凭借精良的制作和扣人心弦的剧情，持续吸引着大量观众。第三季的剧情更加复杂，时间线的交错让观众直呼过瘾。

## 《雾山五行》完结篇

林魂导演的这部作品以其独特的水墨画风和拳拳到肉的打斗场面，成为了国产动画的一面旗帜。完结篇将揭开所有谜团，五行家族的最终命运令人期待。

## 《深海》导演新作

田晓鹏导演在《深海》之后，正在筹备一部全新的原创动画电影。虽然目前信息有限，但凭借《深海》在视觉美学上的突破，新作自然备受关注。

## 平台投入持续加大

主流内容平台在动画领域的投入持续增加，越来越多的优秀创作者获得了展示才华的机会。国产动画的春天，真的来了。`,
    author: '国漫观察',
    authorAvatar: 'editor-avatar-3',
    publishDate: '2025-06-15',
    category: '国漫专区',
    readCount: 7654,
    commentCount: 189,
    tags: ['国产动画', '国漫崛起', '时光代理人'],
    imageSeq: 'article-hero-003',
  },
  {
    id: 'article-004',
    title: '《鬼灭之刃》无限城篇上映倒计时：你需要知道的一切',
    excerpt: '无限城篇三部曲即将上映，我们为你整理了剧情前瞻、角色分析和观影指南。',
    content: `《鬼灭之刃》无限城篇剧场版三部曲即将陆续上映。作为整部作品的最高潮，无限城篇承载了无数粉丝的期待。

## 剧情前瞻

无限城是鬼舞辻无惨的大本营，也是鬼杀队与鬼族决战的最终舞台。炭治郎、祢豆子与其他柱们将在无限城中面对上弦之鬼的全力阻击。每一层都有不同的挑战等待着他们。

## 角色阵容

本次无限城篇将集结所有柱级剑士，包括炎柱·炼狱杏寿郎（在回忆中）、水柱·富冈义勇、虫柱·蝴蝶忍、恋柱·甘露寺蜜璃、蛇柱·伊黑小芭内、风柱·不死川实弥、岩柱·悲鸣屿行冥等。每位柱都将有属于自己的高光时刻。

## 观影指南

三部剧场版将分别于2025年7月、10月和12月上映。建议在观影前补完TV动画第一至第四季的内容，以便更好地理解剧情。IMAX版本将有更加震撼的视听体验。`,
    author: '樱花动漫编辑部',
    authorAvatar: 'editor-avatar',
    publishDate: '2025-07-01',
    category: '热门专题',
    readCount: 15320,
    commentCount: 487,
    tags: ['鬼灭之刃', '无限城', '剧场版'],
    imageSeq: 'article-hero-004',
  },
  {
    id: 'article-005',
    title: '治愈系动漫推荐：十部能让你放下一切烦恼的温柔作品',
    excerpt: '生活太累了？来点治愈番吧！这十部作品用温柔的故事和精致的画面，抚平你的焦虑与疲惫。',
    content: `在这个快节奏的时代，治愈系动漫成为了许多人逃离现实压力的避风港。以下是十部公认的治愈神作，每一部都值得细细品味。

## 1. 《葬送的芙莉莲》

前文已有详细分析，这部作品用极其克制的方式让人感受到时间的珍贵和人际关系的温暖。

## 2. 《摇曳露营△》

一群高中女生的露营日常，没有跌宕起伏的剧情，只有宁静的风景和温暖的友情。每一帧画面都散发着治愈的力量。

## 3. 《夏目友人帐》

关于妖怪与人类的温柔故事，夏目贵志的善良和妖怪们的孤独交织在一起，每一集都让人心头一暖。

## 4. 《三月的狮子》

将棋少年桐山零在人与人的羁绊中逐渐走出孤独，羽海野千花的原作加上SHAFT的精良制作，每一帧都是艺术品。`,
    author: '治愈系研究社',
    authorAvatar: 'editor-avatar-4',
    publishDate: '2025-06-10',
    category: '番剧推荐',
    readCount: 11023,
    commentCount: 298,
    tags: ['治愈系', '番剧推荐', '日常系'],
    imageSeq: 'article-hero-005',
  },
  {
    id: 'article-006',
    title: '异世界题材为何长盛不衰？从《无职转生》到《Re:Zero》',
    excerpt: '异世界题材近年来占据了动画界的半壁江山，它究竟有什么魔力让观众如此着迷？',
    content: `异世界（Isekai）题材在近年来可谓是大行其道，几乎每个季度都有数部异世界题材的新番播出。从早期的《刀剑神域》到现象级的《Re:从零开始的异世界生活》，再到口碑爆棚的《无职转生》，这个题材似乎永远不会过时。

## 为什么异世界如此受欢迎？

异世界题材满足了观众"逃离现实"的心理需求。在异世界中，主角可以摆脱现实世界的束缚，拥有新的身份和能力。这种"重生"的设定给予观众一种替代性的满足感。

## 从套路到创新

早期的异世界作品多是"龙傲天"式的主角无敌套路，但随着观众审美的提高，越来越多的作品开始在这个框架内进行创新。比如《Re:Zero》的死亡回归设定、《无职转生》对角色成长的细腻刻画，都为这个题材注入了新的活力。`,
    author: '二次元观察室',
    authorAvatar: 'editor-avatar-2',
    publishDate: '2025-05-28',
    category: '深度分析',
    readCount: 8934,
    commentCount: 312,
    tags: ['异世界', '动画分析', 'Re:Zero'],
    imageSeq: 'article-hero-006',
  },
];

export const featuredArticles = articles.slice(0, 3);

export function getArticleById(id: string) {
  return articles.find((article) => article.id === id) || null;
}

export function getArticlesByCategory(category: string) {
  return articles.filter((article) => article.category === category);
}
